/*
 * File: SocialAccounts.tsx
 * Project: a-a
 * File Created: Tuesday, 17th June 2025 9:50:50 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Sunday, 21st September 2025 10:41:54 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import React, { useState } from 'react';
import zeplinColor from '../../../../../theme/Color';
import CustomButton from '../../../../shared/CustomButton/CustomButton';
import SocialAccountCard from './SocialAccountCard';
import CustomCard from '../../../../shared/CustomCard/CustomCard';
import CustomModal from '../../../../shared/CustomModal/CustomModal';
import CustomTextField from '../../../../shared/CustomTextField/CustomTextField';
import { useInput } from '../../../../../customHook/useInput';
import validator from 'validator';
const SocialAccounts = ({
  loading,
  data,
}: {
  loading: boolean;
  data: {
    platform: string;
    username: string;
    followers: number;
    url: string;
    profileVerified: boolean;
  }[];
}) => {
  const {
    handleChange: handleLinkChange,
    handleBlur: handleLinkBlur,
    // clearInput: clearMember,
    value: link,
    invalid: invalidLink,
    didChange: didLinkChange,
    setValue: setLink,
    setDidChange: setDidLinkChange,
  } = useInput('', validator.isEmail);
  const [confirmModal, setConfirmModal] = useState(false);
  const [account, setAccount] = useState('');
  const accountList = ['Instagram', 'Facebook', 'Twitter', 'LinkedIn', 'YouTube'];
  const handleSelectAccount = (event: any) => {
    setAccount(event.target.value as string);
  };
  const handleCloseConfirm = () => {
    setConfirmModal(false);
  };
  return (
    <Box
      sx={{
        borderRadius: '14px',
        padding: { xs: '0px 16px 12px 16px', xl: '0px 16px 16px 16px' },
        border: `1px solid ${zeplinColor.Neutral5}`,
        display: 'flex',
        flexDirection: 'column',
        // minHeight: '265px',
        // height: 'fit-content',
        // maxHeight: '338px',
        // gap: '24px',
        // height: '338px',
        // overflowY: 'auto',
        // flex: 1,
        position: 'relative',
        backgroundColor: zeplinColor.Neutral1,
      }}
    >
      {/* <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant='heading3'>Social Accounts</Typography>
        <CustomButton
          disabled={false}
          variant='outlined'
          color='customSecondary'
          style={{
            color: zeplinColor.Brand1,
            // width: '50%',
            margin: '0px',
            padding: '0px 0px',
            borderRadius: '14px',
            height: '48px',
            borderWidth: 1,
            borderColor: zeplinColor.Neutral1,
            display: 'flex',
            alignItems: 'flex-start',
            gap: '8px',
            '&:hover': { backgroundColor: zeplinColor.Neutral3 },
          }}
          text={'Add Link'}
          icon={<img src={'/assets/add-blue.svg'} />}
          onClick={() => {
            setConfirmModal(true);
          }}
          // tabindex={5}
        />
      </Box> */}
      <Box
        sx={{
          // position: 'sticky',
          top: 0,
          width: '100%',
          backgroundColor: zeplinColor.Neutral1,
          // zIndex: 1,
          padding: { xs: '12px 0px 12px 0px', xl: '16px 0px 24px 0px' },
        }}
      >
        <Typography
          variant='responsiveHeading3'
          // sx={{
          //   position: 'sticky',
          //   top: 0,
          //   width: '100%',
          //   backgroundColor: zeplinColor.Neutral1,
          //   zIndex: 1,
          // }}
        >
          Social Accounts
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3,1fr)',
          gap: '16px',
          minHeight: { xs: '200px', xl: '250px' }, // Add minimum height to ensure space for at least 2 rows
          alignContent: 'start',
        }}
      >
        {loading
          ? [1, 2, 3, 4, 5, 6].map((val) => (
              <SocialAccountCard
                key={val}
                platform={''}
                username={''}
                followers={0}
                loading={true}
                url={''}
                verified={false}
              />
            ))
          : data?.map((val, index) => (
              <SocialAccountCard
                key={index}
                platform={val?.platform}
                username={val?.username}
                followers={val?.followers}
                loading={false}
                url={val?.url}
                verified={val?.profileVerified || false}
              />
            ))}
      </Box>
      <CustomModal handleClose={handleCloseConfirm} open={confirmModal}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CustomCard
            styles={{
              borderRadius: '14px',
              padding: '24px',
              backgroundColor: zeplinColor.Neutral1,

              width: '604px',
              // height: '201px',
              boxShadow: 'rgba(0, 0, 0, 0.15)',
              display: 'flex',
              flexDirection: 'column',
              gap: '32px',
              // justifyContent: 'space-between',
            }}
          >
            <Typography variant='heading3'>Add Social Account</Typography>
            <Box sx={{ display: 'flex', gap: '16px' }}>
              <FormControl sx={{ width: '250px' }}>
                <InputLabel id='demo-simple-select-label'>Select account</InputLabel>
                <Select
                  // labelId='demo-simple-select-label'
                  // id='demo-simple-select'
                  value={account}
                  label='Select account'
                  onChange={handleSelectAccount}
                  IconComponent={(props) => (
                    <img src={'/assets/down-arrow.svg'} width={20} height={20} {...props} />
                  )}
                  sx={{ width: '100%' }}
                >
                  {accountList.map((val) => (
                    <MenuItem value={val}>{val}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <CustomTextField
                style={{ width: '100%' }}
                onBlur={handleLinkBlur}
                onChange={handleLinkChange}
                name='Link'
                text={link}
                error={invalidLink && link ? 'Please enter valid email' : ''}
                label={'Link'}
                type='text'
                tabindex={1}
                // required
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '16px',
              }}
            >
              <Box
                onClick={() => {
                  // handleDeleteClose();
                  setConfirmModal(false);
                  setLink('');
                  setDidLinkChange(false);
                }}
                sx={{ display: 'flex', justifyContent: 'flex-end' }}
              >
                <CustomCard
                  styles={{
                    borderRadius: '14px',
                    padding: '14px 32px',
                    backgroundColor: zeplinColor.Neutral1,
                    border: `1px solid ${zeplinColor.BasicBlack}`,
                    cursor: 'pointer',
                    // width: '312px',
                    // height: '183px',
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1,
                    // display: 'flex',
                    // flexDirection: 'column',
                    // justifyContent: 'space-between',
                  }}
                  aria-role='button'
                >
                  <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                    Cancel
                  </Typography>
                </CustomCard>
              </Box>
              <Box onClick={() => {}} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <CustomCard
                  styles={{
                    borderRadius: '14px',
                    padding: '14px 32px',
                    backgroundColor:
                      invalidLink || !link ? zeplinColor.Neutral3 : zeplinColor.Brand1,
                    cursor: 'pointer',
                    // border: `1px solid ${zeplinColor.BasicBlack}`,
                    // width: '312px',
                    // height: '183px',
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1,
                    // display: 'flex',
                    // flexDirection: 'column',
                    // justifyContent: 'space-between',
                  }}
                  aria-role='button'
                >
                  <Typography
                    variant='buttonMedium'
                    color={invalidLink || !link ? zeplinColor.BasicBlack : zeplinColor.Neutral1}
                    sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                  >
                    Add
                  </Typography>
                </CustomCard>
              </Box>
            </Box>
          </CustomCard>
        </Box>
      </CustomModal>
    </Box>
  );
};

export default SocialAccounts;
